import { ValidatorFn, Validators } from '@angular/forms';

export type ShopCouponDiscountGroup = {
  type?: number;
  value?: number | null;
};

export type ShopCouponDiscount = {
  subscriber?: ShopCouponDiscountGroup;
  non_subscriber?: ShopCouponDiscountGroup;
  subscription?: ShopCouponDiscountGroup;
};

export const SHOP_COUPON_FREIGHT_DISCOUNT_TYPE = 3;

export function getShopCouponDiscountValueValidators(
  freeShipping: boolean
): ValidatorFn[] {
  if (freeShipping) {
    return [Validators.min(0)];
  }
  return [Validators.required, Validators.min(0.01)];
}

export function normalizeShopCouponDiscountValue(
  value: number | null | undefined
): number {
  return value ?? 0;
}

export function normalizeShopCouponDiscount(
  discount: ShopCouponDiscount
): ShopCouponDiscount {
  if (!discount) {
    return discount;
  }
  const group = (g?: ShopCouponDiscountGroup) =>
    g ? { ...g, value: normalizeShopCouponDiscountValue(g.value) } : g;
  return {
    subscriber: group(discount.subscriber),
    non_subscriber: group(discount.non_subscriber),
    subscription: group(discount.subscription)
  };
}
